import PropTypes from 'prop-types';
import { Container, Hidden } from '@material-ui/core';

import DriverHireIcon from 'UI/Screens/Main/Sections/Services/Assets/DriverHireIcon';
import BookDriverForm from 'UI/Screens/Main/Sections/Header/Blocks/BookDriverForm/BookDriverForm';
import ImagePresenter from 'UI/Components/ImagePresenter/ImagePresenter';
import { DriverHirebackground } from 'UI/Screens/Services/Assets';
import { useGetDriverContent, useGetDriverPartnerContent } from "../../../Data/ApiHooks/UseContentHook";
import VehicleElement from "./Blocks/VehicleElement/VehicleElement";
import {BASE_URL} from "../../../Constants/Options";

const DriverHireScreen = ({
  branchLocationOptions,
}) => {

  const { data } = useGetDriverContent();
  const { data: driverPartnerData } = useGetDriverPartnerContent();

  return (
    <>
      <div className="service-detail-screen">
        <Container className="service-detail-screen__container">
          <div className="service-detail-screen__left">
            <div className="service-detail-screen__left--title">
              { data?.driver_service_title }
              <DriverHireIcon className="service-detail-screen__left--title--icon" />
            </div>
            <div className="service-detail-screen__left--description">
              { data?.driver_description }
            </div>

            <div className="service-detail-screen__left--content">
            </div>
              {driverPartnerData !== undefined && driverPartnerData.map(vehicle => <VehicleElement key={vehicle.id} vehicle={vehicle} />)}
          </div>
          <div className="service-detail-screen__right">
            <BookDriverForm branchLocationOptions={branchLocationOptions} className="service-detail-screen__right--form" />
          </div>
        </Container>
        <div className="service-detail-screen-background-layer">
          <div className="service-detail-screen-background-layer__left"></div>
          <div className="service-detail-screen-background-layer__right" style={{ backgroundImage: `url(${DriverHirebackground})` }}/>
        </div>
        <Hidden mdUp>
          <ImagePresenter
            containerClass="service-detail-screen__mobile-image-container"
            imageClass="service-detail-screen__mobile-image-container--image"
            src={DriverHirebackground}
          />
        </Hidden>
      </div>
    </>
  );
}

DriverHireScreen.propTypes = {
  branchLocationOptions: PropTypes.object,
};

export default DriverHireScreen;
